import { commonRequest } from '@/utils/request'


const actions = {
  list: ({ commit }, data) => commonRequest({ data, url: '/notice/list' }),
}

export default {
  namespaced: true,
  actions
}
